import * as React from "react";
import { isContainerItem } from "@bloomreach/spa-sdk";
import { getDisplayName } from "@grandvisionhq/utils";
function withHidableContent(Component) {
  const displayName = getDisplayName(Component);
  const WithHidableContent = (props) => {
    const { component, page } = props || {};
    const preview = page?.isPreview();
    const hidden = component && isContainerItem(component) ? component.isHidden() : false;
    if (hidden && !preview) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Component, { ...props });
  };
  WithHidableContent.displayName = `withHidableContent(${displayName})`;
  return WithHidableContent;
}
export {
  withHidableContent
};
//# sourceMappingURL=with-hidable-content.js.map
